import script from "./EmployeeDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeDetailsModal.vue?vue&type=style&index=0&id=19e16f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e16f5e"]])

export default __exports__